import React from 'react';

import styles from './card.module.css';
import CardProps from './types';

const Card: React.FC<CardProps> = ({
  cardClassName,
  containerClassName,
  title,
  subtitle,
  children,
}) => {
  const cardStyles = `${cardClassName} ${styles.cardInstance}`;
  const cardContainerStyles = `${styles.cardContainer} ${containerClassName}`;
  return (
    <div className={cardStyles}>
      <div className={cardContainerStyles}>
        {title && <h3 className={styles.title}>{title}</h3>}
        {subtitle && <h4 className={styles.subtitle}>{subtitle}</h4>}

        <div className={styles.cardContent}>{children}</div>
      </div>
    </div>
  );
};

export default Card;
